<div class="sidenav_mover" [cdkDragFreeDragPosition]="pos" (cdkDragMoved)="dragMove($event)" cdkDragBoundary=".ui-grid"
    cdkDrag>

    <button class="view-adjust-button" mat-icon-button aria-label="">
        <i class="fa-solid fa-arrows-left-right"></i>
    </button>

</div>